import {trigger, state, animate, style, transition} from '@angular/animations';

export function routerTransition() {
  return slideToRight();
}

export function slideToRight() {
  return trigger('routerTransition', [
    state('void', style({position:'absolute', width:'100%', left: '0', top: '0'}) ),
    state('*', style({position:'absolute', width:'100%', left: '0', top: '0'}) ),
    transition(':enter', [
      style({transform: 'translateX(-100%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))
    ]),
    transition(':leave', [
      style({transform: 'translateX(0%)'}),
      animate('0.5s ease-in-out', style({transform: 'translateX(100%)'}))
    ])
  ]);
}



// WEBPACK FOOTER //
// ./src/app/router.animations.ts